import React from 'react'
import { format } from "date-fns";
import { Thead, Tbody, Tr, Td, Text, Box, Center } from "@chakra-ui/react";
import { Table} from "@chakra-ui/react";
import { BiServer } from "react-icons/all";
import "./TouristByAgentReport.css";
import { touristByAgentColumn } from '../../../constants/tableData';

function TouristByAgentReportTable({data, filter}) {
  return (
    <>
        <Box style={{ position: "sticky", left: "0"}} w="100%" mb="10px">
            <Text textAlign="center" fontSize="25px" fontWeight="bold">International Tourist By Tour Agent or FIT</Text>
            <Text textAlign="center">Date: {format(new Date(filter.dateFrom), "dd MMMM")} to {format(new Date(filter.dateTo), "dd MMMM yyyy")}</Text>
        </Box>
        
        {data?.length > 0 ? (
            <Table w="2000px" size="sm" className="agent-report-table" borderRight="1px solid black">
               <Thead className='agent-report-thead'>
                    <Tr color="#4149BE" fontWeight="bold" className='agent-report-thead-tr1'>
                        <Td rowSpan="4" color='white' colSpan="1" textAlign="center">ល.រ</Td>
                        <Td rowSpan="3" color='white' colSpan="1" textAlign="center">TOUR AGENT</Td>
                        <Td rowSpan="1" color='white' colSpan="3" textAlign="center">ទស្សនា ០១ ថ្ងៃ</Td>
                        <Td rowSpan="1" colSpan="3" textAlign="center" px="0">ទស្សនា ០៣ ថ្ងៃ</Td>
                        <Td rowSpan="1" colSpan="3" textAlign="center" px="0">ទស្សនា ០៧ ថ្ងៃ</Td>
                        <Td rowSpan="1" colSpan="4" textAlign="center" px="0">សរុបតាមអាយុ</Td>
                    </Tr>
                    <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='agent-report-thead-tr2'>
                        <Td rowSpan="1" colSpan="1" textAlign="center">យុវជន</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">វ័យកណ្ដាល</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">និវត្តន៍ជន</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">យុវជន</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">វ័យកណ្ដាល</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">និវត្តន៍ជន</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">យុវជន</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">វ័យកណ្ដាល</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">និវត្តន៍ជន</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">យុវជន</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">វ័យកណ្ដាល</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">និវត្តន៍ជន</Td>
                        <Td rowSpan="1" colSpan="1" textAlign="center">សរុបរួម</Td>
                
                    </Tr>
                    <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='agent-report-thead-tr3'>
                        <Td textAlign="center" p="0">12 - 25</Td>
                        <Td textAlign="center" p="0">26 - 59</Td>
                        <Td textAlign="center" p="0">60 Up</Td>
                        <Td textAlign="center" p="0">12 - 25</Td>
                        <Td textAlign="center" p="0">26 - 59</Td>
                        <Td textAlign="center" p="0">60 Up</Td>
                        <Td textAlign="center" p="0">12 - 25</Td>
                        <Td textAlign="center" p="0">26 - 59</Td>
                        <Td textAlign="center" p="0">60 Up</Td>
                        <Td textAlign="center" p="0">12 - 25</Td>
                        <Td textAlign="center" p="0">26 - 59</Td>
                        <Td textAlign="center" p="0">60 Up</Td>
                        <Td textAlign="center" p="0">All Age</Td>
                    </Tr>
                    <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='agent-report-thead-tr4'>
                        <Td textAlign="center" p="0">TOUR AGENT</Td>
                        <Td textAlign="center" p="0">T1D</Td>
                        <Td textAlign="center" p="0">A1D</Td>
                        <Td textAlign="center" p="0">P1D</Td>
                        <Td textAlign="center" p="0">T3D</Td>
                        <Td textAlign="center" p="0">A3D</Td>
                        <Td textAlign="center" p="0">P3D</Td>
                        <Td textAlign="center" p="0">T7D</Td>
                        <Td textAlign="center" p="0">A7D</Td>
                        <Td textAlign="center" p="0">P7D</Td>
                        <Td textAlign="center" p="0">ALL T</Td>
                        <Td textAlign="center" p="0">ALL A</Td>
                        <Td textAlign="center" p="0">ALL P</Td>
                        <Td textAlign="center" p="0">ALL Age</Td>
                    </Tr>
                </Thead>
                <Tbody>
                    {data?.map((val, index) =>  {
                        return (
                            <Tr key={index} h="25px">
                                {touristByAgentColumn.map((item, i) => {
                                    return (
                                        <Td 
                                            key={i} 
                                            w={item.columnId === "n" ? "40px" : item.columnId === "tourAgent" ? "200px" : "100px"}
                                            textAlign={item.textAlign}
                                            height="35px" 
                                            py="0" 
                                            p="2px" 
                                            bg={(index===data.length-1) ? "#8497b0 !important" : "white" } 
                                            color={(index===data.length-1) ? "white !important" : "black" } 
                                        >
                                            {val[item.columnId]}
                                        </Td>
                                    )
                                })}
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
        ) : (
            <Center py="3" w="full" h="70vh" color="gray.400">
                <BiServer size="1.3rem" /> <Text fontSize="md">&nbsp;No data.</Text>
            </Center>
        )}
    </>
  )
}

export default TouristByAgentReportTable
